import { withInstall } from '@ll-plus/utils'

import BreadcrumbCard from './src/breadcrumb-card.vue'

export const LlBreadcrumbCard = withInstall(BreadcrumbCard)
export default LlBreadcrumbCard
export * from './src/breadcrumb-card'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlBreadcrumbCard: typeof BreadcrumbCard
  }
}
